import { useState, useEffect } from 'react';

const useWindowSize = () => {
  // Initialize with a default width that ensures desktop styling is applied initially
  // This prevents flickering on page refresh
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth || 1200, // Default to 1200 if innerWidth is not available
    height: window.innerHeight || 800,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;